export const DENY_REASON_TEXT = {
    NOT_STAFF: {
        title: "Нет доступа к Диспетчеру",
        description: "Интерфейс доступен только диспетчерам и администраторам оператора. Если вам нужен доступ — обратитесь к администратору.",
    },
    CORP_BLOCKED: {
        title: "Доступ заблокирован",
        description: "Учётная запись администратора компании заблокирована или не привязана к компании. Обратитесь к оператору сервиса.",
    },
    CORP_DISABLED: {
        title: "Кабинет компании недоступен",
        description: "Кабинет корпоративного клиента пока не включён. Обратитесь к оператору сервиса.",
    },
    CORP_OTP_FORBIDDEN: {
        title: "Вход по коду недоступен",
        description: "Администратор компании входит только по email и паролю.",
    },
    RESOLVE_FAILED: {
        title: "Не удалось проверить права доступа",
        description: "Попробуйте войти ещё раз. Если ошибка повторяется — обратитесь к администратору.",
    },
};
